import React from "react";
import {translate} from "../../i18n/translate";
import styles from "../../css/common/loadingAnimation.less";

class LoadingAnimation extends React.Component {
    render() {
        const message = this.props.message ? this.props.message : translate('Loading') + '...';
        return (
            <div className="loading-animation-container">
                <div className="loading-animation"/>
                <div className="loading-text">{message}</div>
            </div>
        );
    }
}

export default LoadingAnimation;


// WEBPACK FOOTER //
// ./src/components/common/LoadingAnimation.js